'use strict';

var AllocationAuthAvailStrategyTemplatePreviewDirective = function AllocationAuthAvailStrategyTemplatePreviewDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmTemplatePreview',
    template: require('../templates/allocation-auth-avail-strategy-template-preview.html')
  };
};
AllocationAuthAvailStrategyTemplatePreviewDirective.$inject = [];
module.exports = AllocationAuthAvailStrategyTemplatePreviewDirective;